import api from './api.ts';

export type RegistrationStatus = 'pending' | 'approved' | 'rejected';

export interface CompanyVerification {
  cnpj: string;
  legal_name: string;
  trade_name?: string | null;
  registration_status: number;
  provider: string;
  checked_at: string;
}

export interface RegistrationApplication {
  id: number;
  status: RegistrationStatus;
  cnpj: string;
  legal_name: string;
  clinic_name: string | null;
  requester_name: string;
  email: string;
  phone: string;
  company_verification: CompanyVerification;
  created_at: string;
  reviewed_at: string | null;
  reviewed_by_client_id: number | null;
  review_reason: string | null;
  clinic_id: number | null;
  client_id: number | null;
  activation_status?: 'pending' | 'activating' | 'dispatched' | 'needs_reconciliation';
}

export interface RegistrationList {
  items: RegistrationApplication[];
  total: number;
  limit: number;
  offset: number;
}

export interface RegistrationDecision {
  status: 'approved' | 'rejected';
  registration_id: number;
  clinic_id?: number;
  client_id?: number;
  activation_status?: 'activating' | 'dispatched' | 'needs_reconciliation';
}

export const listRegistrationApplications = async (status: RegistrationStatus, offset = 0, limit = 25): Promise<RegistrationList> => (
  await api.get('/api/admin/registrations', { params: { status, offset, limit } })
).data;

export const approveRegistrationApplication = async (id: number): Promise<RegistrationDecision> => (
  await api.post(`/api/admin/registrations/${id}/approve`, { confirmed: true })
).data;

export const rejectRegistrationApplication = async (id: number, reason: string): Promise<RegistrationDecision> => (
  await api.post(`/api/admin/registrations/${id}/reject`, { reason })
).data;

export function registrationApprovalError(error: unknown): string {
  const response = (error as { response?: { status?: number; data?: { detail?: unknown } } })?.response;
  if (response?.status === 403) return 'Acesso exclusivo da administração da plataforma.';
  if (response?.status === 409) return 'O cadastro mudou ou já foi analisado. Atualize a lista para conferir a situação atual.';
  const detail = response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (detail && typeof detail === 'object' && 'message' in detail && typeof detail.message === 'string') return detail.message;
  return 'Não foi possível concluir a operação. Tente novamente.';
}
